import { executeReport, REPORT_TYPES } from '../../../../../../../../../../logic/utils/reportRequest';

export default async function SqlAvgWaitTime(startTime, endTime) {
  // Получаем данные через новый API
  const result = await executeReport(REPORT_TYPES.GENERAL_AVG_WAIT_TIME, { startTime, endTime });

  // Возвращаем в том же формате - dataObjects уже имеют числовые индексы
  return { dataObjects: result.dataObjects, query: result.query };
}
